// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListTree as RawListTree } from "lucide-react";
export const ListTree = /* @__PURE__ */ createIcon(RawListTree, "ListTree", 2);
